import { isRejectedWithValue } from "@reduxjs/toolkit";
import type { MiddlewareAPI, Middleware } from "@reduxjs/toolkit";
import { logout } from "store/Slices/appStateSlice";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { UNAUTHORIZED_ERROR_CODE } from "constants/error/ErrorCodes";

export const logoutUserOnUnauthorizedError: Middleware =
  (api: MiddlewareAPI) => next => action => {
    if (isRejectedWithValue(action)) {
      if (action.error && action.payload) {
        const payload = action.payload as FetchBaseQueryError;
        if (payload.status == UNAUTHORIZED_ERROR_CODE) api.dispatch(logout());
      }
    }

    return next(action);
  };
